// extracted by mini-css-extract-plugin
export default {"CloseButton":"CloseButton__CloseButton___Nxt2r","name":"CloseButton__name___Rqt9D"};